export const getYmalRecommendations = async (productId, categoryId, pageUrl, elementsId) => {
  if (typeof window.$g === 'undefined') {
    console.error('GrapheneHC ($g) is not available.');
    return;
  }

  const { locale } = window.inlineGlobalConfig || {};
  const languageId = locale.isoCode.toLowerCase().replace('_', '-');

  const urlObj = new URL(pageUrl || window.location.href, window.location.origin);

  if (locale.country) {
    urlObj.searchParams.set('site-searchability', locale.country.toLowerCase());
  }

  const finalPageUrl = urlObj.href;

  const payload = {
    args: {
      region_filter: locale.country.toLowerCase(),
    },
    page_context: {
      product_id: productId.toLowerCase(),
      category_id: categoryId,
      page_url: finalPageUrl,
      language_id: languageId,
      currency_id: locale.currentCurrency.toLowerCase(),
    },
    elements: [elementsId],
    response_options: {
      fields: {
        products: ['id', 'sku', 'stock', 'slug', 'url', 'titles', 'abstracts', 'media', 'pricing'],
      },
    },
  };

  // eslint-disable-next-line consistent-return
  return window.$g.json(payload);
};

export const adaptGrapheneProductToHybris = (gProductItem, currencySymbol) => {
  const imageSet = gProductItem.media ? Object.values(gProductItem.media).map(img => img.src) : [];

  return {
    id: gProductItem.id,
    url: gProductItem?.slug || gProductItem.url,
    name: gProductItem?.titles.default,
    description: gProductItem?.titles?.default || gProductItem?.abstracts?.default,
    imageSet,
    price: {
      symbol: currencySymbol,
      value: gProductItem?.pricing?.price || 0,
    },
    wasPrice: gProductItem?.pricing?.was
      ? {
          symbol: currencySymbol,
          value: gProductItem?.pricing?.was || 0,
        }
      : null,

    heroBadges: [],
    promoBadges: [],
    primaryCategoryName: '',
    productAge: null,
    dataLayerDescription: {},
    classificationData: {},
  };
};

export const removeExternalTitle = () => {
  const titleElement = document.querySelector('.product-carousel__title');
  if (titleElement) {
    titleElement.remove();
  }
};
